export default __webpack_public_path__ + "static/discordChatImg-8ad76804a9e949b908a4101a471be071.png";